import React, { useState, useContext } from "react";
import List from "@mui/material/List";
import ListSubheader from "@mui/material/ListSubheader";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import Tooltip from "../../Common/Tooltip/Tooltip";
import { DynamicContext } from "../../Context/DynamicContext";

export default function NestedList({
  items,
  title,
  activeLink,
  setActiveLink,
  closeTab,
  onLinkClick,
  triggerNames = [],
}) {
  const { isDarkMode, setHideCandidatesHeader } = useContext(DynamicContext);
  const [open, setOpen] = useState({});
  const navigate = useNavigate();
  const handleToggle = (name) => {
    setOpen((prevState) => ({ ...prevState, [name]: !prevState[name] }));
  };

  const handleLinkClick = (path, name) => {
    setHideCandidatesHeader(true);
    if (activeLink === name) {
      return;
    }
    if (onLinkClick && triggerNames.includes(name)) {
      onLinkClick(name, path);
    } else {
      setActiveLink(name);
      navigate(path);
    }
  };

  const renderItems = (items, level = 0) =>
    items.map((item) => (
      <div className="sub-menus" key={item.name}>
        <React.Fragment>
          <Tooltip title={closeTab ? item.name : ""} placement="right">
            <ListItemButton
              className={activeLink === item.name ? "active" : ""}
              onClick={
                item.children
                  ? () => handleToggle(item.name)
                  : () => handleLinkClick(item.path, item.name)
              }
              sx={{
                pl: level * 4,
                bgcolor:
                  activeLink === item.name
                    ? isDarkMode
                      ? "#2D2D2D"
                      : "#EEEDFF"
                    : isDarkMode
                      ? "transparent"
                      : "transparent",
                color: isDarkMode
                  ? activeLink === item.name
                    ? "#FFFFFF"
                    : "#FFFFFF"
                  : activeLink === item.name
                    ? "#6860ee"
                    : "#585858",
                border: isDarkMode
                  ? activeLink === item.name
                    ? "1px solid #FFFFFF"
                    : "none"
                  : activeLink === item.name
                    ? "none"
                    : "none",
                borderRadius: "5px",
                paddingLeft: "10px",
                marginBottom: "5px",
                gap: "6px",
                display: "flex",
                justifyContent: "center",
                position: "relative",
                "&:hover": {
                  bgcolor:
                    activeLink === item.name
                      ? isDarkMode
                        ? "#2D2D2D"
                        : "#e7e5ff"
                      : "var(--account_Tab_Hover)",
                  border: isDarkMode ? "1px solid #FFFFFF" : "none",
                },
                "@media (max-width: 768px)": {
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                },
                "@media (max-width: 1440px)": {
                  gap: "8px",
                },
                "&.active:hover": {
                  cursor: "default",
                },
              }}
              style={{
                cursor: activeLink === item.name ? "default" : "pointer",
              }}
            >
              <ListItemIcon>
                <span style={{ position: "relative", display: "inline-flex" }}>
                  <img
                    src={activeLink === item.name ? item.activeIcon : item.icon}
                    alt={item.name}
                    style={{ width: 24, height: 24, position: "relative" }}
                  />
                  {item.badgeContent > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: "-7px",
                        right: "-9px",
                        minWidth: "16px",
                        height: "16px",
                        padding: "0 4px",
                        borderRadius: "999px",
                        backgroundColor: "#F04438",
                        color: "#FFFFFF",
                        fontSize: "10px",
                        fontWeight: 700,
                        lineHeight: "16px",
                        textAlign: "center",
                        boxSizing: "border-box",
                      }}
                    >
                      {item.badgeContent > 99 ? "99+" : item.badgeContent}
                    </span>
                  )}
                </span>
              </ListItemIcon>
              {!closeTab && (
                <ListItemText
                  primary={item.name}
                  primaryTypographyProps={{
                    style: {
                      fontSize: "17px",
                      fontWeight: "500",
                      letterSpacing: "-0.2px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    },
                  }}
                />
              )}
              {item.children && (
                <>
                  {open[item.name] ? (
                    <ExpandLess
                      sx={{
                        position: "absolute",
                        right: "5px",
                      }}
                    />
                  ) : (
                    <ExpandMore
                      sx={{
                        position: "absolute",
                        right: "5px",
                      }}
                    />
                  )}
                </>
              )}
            </ListItemButton>
          </Tooltip>
          {item.children && (
            <Collapse in={open[item.name]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {renderItems(item.children, level + 1)}
              </List>
            </Collapse>
          )}
        </React.Fragment>
      </div>
    ));

  return (
    <List
      sx={{
        width: "100%",
        maxWidth: 360,
        bgcolor: isDarkMode ? "#1e1e2f" : "background.paper",
        color: isDarkMode ? "#ffffff" : "text.primary",
      }}
      subheader={
        <ListSubheader
          component="div"
          sx={{
            bgcolor: isDarkMode ? "#1e1e2f" : "background.paper",
            color: isDarkMode ? "#ffffff" : "text.primary",
          }}
        >
          {title}
        </ListSubheader>
      }
    >
      {renderItems(items)}
    </List>
  );
}
